import { Component, NgZone } from '@angular/core';
import { NavController } from 'ionic-angular';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../app/configuration';
import * as moment from 'moment'
import { Platform } from 'ionic-angular';
import { LivraisonPage } from '../livraison/livraison';

declare var google;

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {

  Adresse_Select: string;
  GoogleAutocomplete: any;
  autocomplete: { input: string; };
  autocompleteItems: any[];
  valide: boolean;
  placeid: any;
  step : number
  setpoids: any;
  Dates: any[];
  Jour_Livraison: any;
  Heures: any[];
  jour_liv_choisit: boolean;
  Heure_Drive: any;
  lastname : string
  firstname : string
  phone : string
  username : string
  com_adr : string  

  Livraisons: any[];
  TasksAnnounced: any[];
  dateclefs: any[];
  heureclefs: any[];
  Livraisons_Filter: any[];
  filtermode: any;

  route_request : any
  Livraisons_Filter_sorted: any[];
  fromview: string;
  nom_etablissement : string
  actualhour: number;
  actualdate: string;

  constructor(public platform: Platform, public navCtrl: NavController, public zone: NgZone, private httpClient : HttpClient, public configuration: AppConfig ) {

    this.Adresse_Select = "";
    this.GoogleAutocomplete = new google.maps.places.AutocompleteService();
    this.autocomplete = { input: '' };
    this.autocompleteItems = [];

    if(localStorage.getItem("nom_etablissement") != null) {
      this.step = 0
    } 
    else {
      this.step = -1
    }
    
    this.setpoids = ''
    this.Dates = [];
    this.Heure_Drive = ""
    this.actualhour = moment().hour() ; console.log("this.actualhour -> ", this.actualhour )
    this.actualdate = String(moment().date()) ; console.log("this.actualdate -> ", this.actualdate )

  //  this.Heures = ["09h à 10h","10h à 11h","11h à 12h","12h à 13h","13h à 14h","14h à 15h","15h à 16h","16h à 17h","17h à 18h","18h à 19h","19h à 20h","20h à 21h"];
    this.Heures = [
      {
        id : 9,
        val:"9h à 10h"
      },
      {
        id : 10,
        val:"10h à 11h"},
      {
        id : 11,
        val:"11h à 12h"},
      {
        id : 12,
        val:"12h à 13h"},
      {
        id : 13,
        val:"13h à 14h"},
      {
        id : 14,
        val:"14h à 15h"},
      {
        id : 15,
        val:"15h à 16h"},
      {
        id : 16,
        val:"16h à 17h"},
      {
        id : 17,
        val:"17h à 18h"},
      {
        id : 18,
        val:"18h à 19h"},
      {
        id : 19,
        val:"19h à 20h"},
      {
        id : 20,
        val:"20h à 21h"}
    ];

  this.jour_liv_choisit = false;

    if(localStorage.getItem("filtermode") == null || localStorage.getItem("filtermode") == undefined){
      this.filtermode = "Livrer"
    } else {
      this.filtermode = localStorage.getItem("filtermode")
    }

    if(localStorage.getItem("fromview") == null || localStorage.getItem("fromview") == undefined){
      this.fromview = "Accueil"
    } else {
      this.fromview = localStorage.getItem("fromview")
    }

    console.log("fromview -> ", this.fromview)

    this.lastname = ""
    this.firstname = ""
    this.phone = ""
    this.username = ""
    this.com_adr = ""
    this.nom_etablissement = localStorage.getItem("nom_etablissement")
    console.log("nom_etablissement -> " , localStorage.getItem("nom_etablissement"))

    this.Livraisons = this.configuration.Livraisons
    this.TasksAnnounced = this.configuration.TasksAnnounced

  //  this.route_request = {"code":"Ok","waypoints":[{"distance":10.237847507176927,"name":"McAllister Street","location":[-122.420019,37.780091],"waypoint_index":0,"trips_index":0},{"distance":1858.8590212882514,"name":"Playa Verde","location":[-122.461997,37.89621],"waypoint_index":1,"trips_index":0},{"distance":4.350951991859006,"name":"","location":[-122.480005,37.730039],"waypoint_index":2,"trips_index":0}],"trips":[{"geometry":"q|qeFbdejVf@xJufB~SjMhpBg\\|DiZjh@tGflAaKjn@}Zlb@qlCjSip@hi@_o@]mz@|o@aj@hgAi`A|Jil@pt@whCcLnY}wAjU_]yt@ysBrFuQvNx@{AkS`ZgIuAgj@tAfj@aZfIzAjSwNy@sFtQ~s@jtB_Uj[o]jiBboCwA~j@et@t`AeK|i@egAlx@{m@lp@Shp@_j@zfCoO`j@mo@r_Ab@zc@|Q~pAqD~F`o@lqFa[jOzDV`X`U_^~vAqR`NwuAsb@_u@_u@iM}X{XoU}dAX}dByPei@gkBsc@}p@jT_l@{E{NxRyAreA_|@hA","legs":[{"summary":"","weight":2350.6,"duration":1795,"steps":[],"distance":25780},{"summary":"","weight":2601.6,"duration":1878.7,"steps":[],"distance":28828.6},{"summary":"","weight":1575.8,"duration":1054.5,"steps":[],"distance":16123.2}],"weight_name":"routability","weight":6528,"duration":4728.2,"distance":70731.8}]}
  console.log("Livraison -> ", this.Livraisons)
  console.log("TasksAnnounced -> ", this.TasksAnnounced)
  //  console.log("route_request -> ", this.route_request)

    this.DisplayDateToDeliver()

    // this.httpClient.post("http://127.0.0.1:3000/mail",{tomail: "babakar.wade.31@gmail.com",subject:"Test"}).subscribe(data => { 

    // console.log("data -> ", data)

    // })

  }

  ionViewDidEnter() {
    console.log('ionViewDidEnter HomePage');
    this.DisplayLivraisons()
  }

  DisplayLivraisons(){

    this.dateclefs = []; 
    this.heureclefs = [],
    this.TasksAnnounced.map((item, index) => {
      this.dateclefs.push(item.timeWindow.start.slice(0, 10))
      this.heureclefs.push(item.timeWindow.start.slice(11, 13))
    })

    this.dateclefs = this.dateclefs.reduce((acc, current) => {
      const x = acc.find(item => item === current);
      if (!x) {
        return acc.concat([current]);
      } else {
        return acc;
      }
    }, []);

    this.heureclefs = this.heureclefs.reduce((acc, current) => {
      const x = acc.find(item => item === current);
      if (!x) {
        return acc.concat([current]);
      } else {
        return acc;
      }
    }, []);

    console.log("API this.dateclefs",  this.dateclefs)
    console.log("API this.dateclefs",  this.heureclefs)
    
    this.Filter(this.filtermode)


    // this.dateclefs = []; 
    // this.Livraisons.map((item, index) => {
    //   this.dateclefs.push(item.Jour_Livraison)
    // })

    // this.dateclefs = this.dateclefs.reduce((acc, current) => {
    //   const x = acc.find(item => item === current);
    //   if (!x) {
    //     return acc.concat([current]);
    //   } else {
    //     return acc;
    //   }
    // }, []);

    // this.Filter(this.filtermode)


  }

  DelivThisDate(date) {

    return this.Livraisons_Filter.filter(liv => liv.timeWindow.start.slice(0, 10) == date).length > 0

  }

  DelivThisheure(heure) {

    return this.Livraisons_Filter.filter(liv => liv.timeWindow.start.slice(11, 13) == heure).length > 0

  }

  Choix_Heure_Drive(heure){
    this.Heure_Drive = heure
  }

  DisplayDateToDeliver() {

    var delay : any
    delay = 0

    var localLocale = moment(); localLocale.locale('fr');

    var heure_limite = 0
    if (moment().hour() >= 20) {heure_limite = 1}

    for (var i = 0; i < 30; i++)
    {
      this.Dates.push(moment(localLocale).add(i + delay + heure_limite, 'days'))
    }

  //  console.log("Dates -> ",this.Dates)

  }

  Dateme(date){

    const maDate = new Date(date)
    return maDate.toLocaleDateString("fr-FR",{ weekday: 'long', month: 'long', day: 'numeric' }) // 20/10/2021
  }

  Istoday(date){

    return new Date(date) == new Date()

  }

  Choix_Jour_Livraison(Date) {
    this.Jour_Livraison = Date
    this.jour_liv_choisit = true
    console.log("this.Jour_Livraison -> ", this.Jour_Livraison.slice(0,2))
  }

  Filter(state) {

    this.filtermode = state
    localStorage.setItem("filtermode",state)

    if(state == 'Collecter'){this.Livraisons_Filter = this.TasksAnnounced.filter(liv => liv.status == "PREPARED" );}
    if(state == 'Livrer'){this.Livraisons_Filter = this.TasksAnnounced.filter(liv => (liv.status == "PICKED_UP") || (liv.status == "DEPARTED") );}
    if(this.fromview == 'Historique'){this.Livraisons_Filter = this.TasksAnnounced.filter(liv => liv.status == "DELIVERED" );}

    console.log("Livraisons_Filter -> ", this.Livraisons_Filter, this.filtermode)

    this.SortIntineraire(this.Livraisons_Filter)
    
    // if(state == 'Collecter'){this.Livraisons_Filter = this.Livraisons.filter(liv => liv.suivi.preparation.value == true && liv.suivi.collect.value == false && liv.suivi.transport.value == false && liv.suivi.livraison.value == false );}
    // if(state == 'Livrer'){this.Livraisons_Filter = this.Livraisons.filter(liv => liv.suivi.preparation.value == true && liv.suivi.collect.value == true && liv.suivi.livraison.value == false);}
    // if(this.fromview == 'Historique'){this.Livraisons_Filter = this.Livraisons.filter(liv => liv.suivi.livraison.value == true);}

    // console.log("Livraisons_Filter -> ", this.Livraisons_Filter, this.filtermode)

    // this.SortIntineraire(this.Livraisons_Filter)

  }

  SortIntineraire(Livraisons_Filter){

    var coordonnees = [];
    var temp = Livraisons_Filter.filter(liv => liv.timeWindow.start.slice(0, 10) == this.dateclefs[0])
    console.log("To sort ->",temp,"avec", this.dateclefs[0] )
    var counter = 0

    temp.map(item => {
    //  coordonnees.push(item.location.location.geometry[0] + "," +item.location.location.geometry[1]) //Remplacer ce 0 par un 1 pour prendre le lat

    this.httpClient.get('https://api.mapbox.com/geocoding/v5/mapbox.places/'+ encodeURIComponent(item.location.address) + '.json' + '?access_token=' + this.configuration.MapBoxKey)
    .subscribe(data => { 
      console.log("MapBox | geocoding -> ", JSON.parse(JSON.stringify(data)))
      coordonnees.push(JSON.parse(JSON.stringify(data)).features[0].geometry.coordinates[0] + "," + JSON.parse(JSON.stringify(data)).features[0].geometry.coordinates[1]) //Remplacer ce 0 par un 1 pour prendre le lat
      counter ++
      if(counter == temp.length || counter == 12) {

        if(coordonnees.length > 1 && this.fromview != 'Historique') { 

        //  console.log(coordonnees.join(";"))
    
          this.httpClient.get('https://api.mapbox.com/optimized-trips/v1/mapbox/driving-traffic/' + coordonnees.join(";") + '?access_token=' + this.configuration.MapBoxKey)
          .subscribe(data => { 
    
            console.log("MapBox | optimized-trips ->", data)
            this.Livraisons_Filter_sorted = [];
            
            JSON.parse(JSON.stringify(data)).waypoints.map(item => {
              this.Livraisons_Filter_sorted.push(Livraisons_Filter[item.waypoint_index])
            })
    
            console.log("Livraisons_Filter_sorted -> ", this.Livraisons_Filter_sorted, this.filtermode)
    
    
          })
    
        } else {
    
    
          this.Livraisons_Filter_sorted = Livraisons_Filter
    
        }

      }
    })

  })



  }

  UpdateSearchResults(){
    if (this.autocomplete.input == '') {
      this.autocompleteItems = [];
      return;
    }
    this.GoogleAutocomplete.getPlacePredictions({ input: this.autocomplete.input,componentRestrictions: {country: 'fr'} },
    (predictions, status) => {
    //  console.log("predictions -> ", predictions[0].place_id)
    //  console.log("status -> ", status)

      this.autocompleteItems = [];
      this.zone.run(() => {
        predictions.forEach((prediction) => {
          this.autocompleteItems.push(prediction);
        });
      });
    });
  }
    
    //wE CALL THIS FROM EACH ITEM.
    SelectSearchResult(item) {
    //  console.log(item)

      this.GetCoord(item.place_id)

      ///WE CAN CONFIGURE MORE COMPLEX FUNCTIONS SUCH AS UPLOAD DATA TO FIRESTORE OR LINK IT TO SOMETHING
    //  alert(JSON.stringify(item))      
      this.placeid = item.place_id
      this.valide = true
      this.ClearAutocomplete()
    }
    
    
    //lET'S BE CLEAN! THIS WILL JUST CLEAN THE LIST WHEN WE CLOSE THE SEARCH BAR.
    ClearAutocomplete(){
      this.autocompleteItems = []
      this.autocomplete.input = ''
    }

    GetCoord(place_id) {
  
      this.httpClient.get('https://maps.googleapis.com/maps/api/geocode/json?place_id=' + place_id + '&key=' + this.configuration.Google_Places_Api_Key)
          .subscribe(data => { 
            console.log(JSON.parse(JSON.stringify(data)).results[0].geometry.location.lat)
            console.log(JSON.parse(JSON.stringify(data)).results[0].geometry.location.lng)
            console.log(JSON.parse(JSON.stringify(data)))
            this.Adresse_Select = JSON.parse(JSON.stringify(data)).results[0].formatted_address;
            // var localisation = {lat:JSON.parse(JSON.stringify(data)).results[0].geometry.location.lat,lng:JSON.parse(JSON.stringify(data)).results[0].geometry.location.lng}
            this.step ++

          })
    }


    VoirLivraison(livraison) {

      this.navCtrl.push(LivraisonPage, {"livraison":livraison})


    }



    Next(operation) {

      if(this.step == -1) {
        localStorage.setItem("nom_etablissement",this.nom_etablissement)
      }

      if(operation == 'plus') {this.step ++}
      else if(operation == 'moins') {this.step --}

      if(this.step == 6) {
        this.step = 0;       
      }

      if(this.step == 5) {
        //Send mail
        var localLocale = moment()
        this.httpClient.post("https://bo-cchezvous.coterie-francaise.fr/transportorder",{

          tomail: "babakar.wade.31@gmail.com",
          subject:"Nouvelle livraison - " + localLocale + " (" + this.nom_etablissement + ")", 
          firstname:this.firstname,
          lastname:this.lastname,
          username:this.username,
          phone:this.phone,
          Adresse_Select:this.Adresse_Select,
          com_adr:this.com_adr,
          Jour_Livraison:this.Jour_Livraison,
          Heure_Drive:this.Heure_Drive,
          setpoids:this.setpoids,
        
      }).subscribe(data => {console.log("data -> ", data); this.Adresse_Select=""; this.valide=false})

      this.httpClient.post("https://bo-cchezvous.coterie-francaise.fr/transportorder",{ 

        tomail: "transportr23@gmail.com",
        subject:"Nouvelle livraison - " + localLocale + " (" + this.nom_etablissement + ")", 
        firstname:this.firstname,
        lastname:this.lastname,
        username:this.username,
        phone:this.phone,
        Adresse_Select:this.Adresse_Select,
        com_adr:this.com_adr,
        Jour_Livraison:this.Jour_Livraison,
        Heure_Drive:this.Heure_Drive,
        setpoids:this.setpoids,
      
    }).subscribe(data => {console.log("data -> ", data); this.Adresse_Select=""; this.valide=false})    
    
    
    this.httpClient.post("https://bo-cchezvous.coterie-francaise.fr/transportorder",{ 

      tomail: "cchezvouslivraison@gmail.com",
      subject:"Nouvelle livraison - " + localLocale + " (" + this.nom_etablissement + ")", 
      firstname:this.firstname,
      lastname:this.lastname,
      username:this.username,
      phone:this.phone,
      Adresse_Select:this.Adresse_Select,
      com_adr:this.com_adr,
      Jour_Livraison:this.Jour_Livraison,
      Heure_Drive:this.Heure_Drive,
      setpoids:this.setpoids,
    
  }).subscribe(data => {console.log("data -> ", data); this.Adresse_Select=""; this.valide=false})  



      }

    }


    SelectPoids(set) {
      this.setpoids = set
      console.log("poids -> ", this.setpoids)
      this.Next('plus')
    }


}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts